import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { formatNumber, formatNumberForIntegralPart } from '../../../utils/number';

import FlexBox from '../../../components/FlexBox';

const VoteResult = styled(FlexBox)`
  margin-bottom: 30px;
  background: #fff;
  padding: 24px 30px;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.05);
  flex-wrap: nowrap;
  
  .driver {
    flex: 1;
    max-width: ${({ maxWidth }) => maxWidth || 61}px;
    display: flex;
    justify-content: center;
    
    &::before {
      content: '';
      height: 52px;
      width: 1px;
      background: #EAECEF;
    }
    
    &.add {
      max-width: ${({ maxWidth }) => (maxWidth || 61) + 23}px;
      
      &::before {
        width: 24px;
        height: 24px;
        background: url(${require('../images/icon-add.png')}) no-repeat center/100%;
      }
    }
  }
  
  .vote-tle {
    background: url(${require('../images/crown.png')}) no-repeat left/auto 80px;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-size: 20px;
    line-height: 28px;
    padding-left: 88px;
  
    > a {
      font-size: 14px;
      color: #F0B90B;
    }
  }
  
  .vote-cot {
    font-size: 14px;
    
    .bnb-info { margin-top: 8px; }
  }
  
  .vote-ext {
    > li {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin-bottom: 10px;
      flex-wrap: wrap;
      
     > span {
      flex: none;
      display: flex;
      align-items: center;
      
      &::before {
        flex: none;
        margin-top: 2px;
        content: '';
        background: #3769F9;
        width: 14px;
        height: 14px;
        border-radius: 100px;
        margin-right: 8px;
        margin-bottom: 2px;
       }
     }
     
     &:last-of-type{
      margin-bottom:0px;
      
      > span::before { background: #ED4727; }
     }
      
      .bnb-info { 
        margin-left: 6px;
        font-size: 16px;
        
        > i {
          width: 20px;
          height: 20px;
        }
      }
    }
  }
  
  @media screen and (min-width: 768px) and (max-width: 992px) {
    margin-bottom: 20px;
    padding: 24px 16px;
    flex-direction: column;
    
    .driver {
      margin: 20px 0;

      &.line {
        &::before {
          content: '';
          height: 5px;
          width: 100px;
          background: transparent;
        }
     }
    }
    
    .vote-tle { margin-top: 14px; }
    
    .vote-cot {
      display: flex;
      align-items: center;
      
      .bnb-info {
        margin-top: 0;
        margin-left: 8px;
      }
    }
  }
  
  @media screen and (max-width: 414px) {
    margin-bottom: 20px;
    padding: 24px 16px;
    flex-direction: column;
    
    .driver {
      margin: 15px 0;

      &.line::before {
        content: '';
        height: 5px;
        width: 100px;
        background: transparent;
     }
     
     &.add::before {
        width: 15px;
        height: 15px;
     }
    }
    
    .vote-tle { margin-top: 14px; }
    
    .vote-cot {
      display: flex;
      align-items: center;
      
      .bnb-info {
        margin-top: 0;
        margin-left: 8px;
      }
    }
    
    .vote-ext > li {
      justify-content: center;
    }
  }
`;

const VoteResultCenter = styled(VoteResult)`
  justify-content: center;
  flex-wrap: wrap;
  min-height: 113px;
  
  .res-tel {
    font-size: 24px;
    line-height: 31px;
    font-weight: normal;
    padding: 10px;
    text-align: center;
  }
  
  .profit-list {
    display: flex;
    padding: 10px 0;
    justify-content: center;
    
    .bnb-info {
      margin: 0 10px;
    }
  }
`;

const { object, string, bool } = PropTypes;

const bnbLogoUrl = 'https://bin.bnbstatic.com/static/images/home/coin-logo/BNB.png';

const scrollToRule = () => {
  const ruleTerm = document.querySelector('#rule-term');
  if (ruleTerm instanceof Element) {
    const { top } = ruleTerm.getBoundingClientRect();
    window.scrollTo(0, top);
  }
};

const Reward = ({
  language, project, locale, isLoggedIn,
}) => {
  const {
    options = [],
    rule: { bnbReward, rdrop },
    product: { status }, profit,
  } = project || {};

  if (rdrop !== 1 || ['2', '3', '4'].indexOf(`${status}`) === -1) return null;

  const {
    title,
    profitTitle,
    profitExt,
    rule: nextRule,
    success: successText,
    fail: failText,
  } = language || {};

  const { bnbProfit, optionCoin, optionProfit } = profit || {};
  if (['2', '3'].indexOf(`${status}`) > -1 || !isLoggedIn) {
    return (
      <VoteResult maxWidth={locale === 'cn' ? 121 : 61}>
        <div className="vote-tle">
          {title}<a onClick={scrollToRule}>{nextRule}</a>
        </div>
        <i className="driver line" />
        {bnbReward > 0 ? (
          <div className="vote-cot">
            <span>{profitTitle}</span>
            <div className="bnb-info">
              <i style={{ backgroundImage: `url('${bnbLogoUrl}')` }} />
              {`${formatNumber(bnbReward)} ${'BNB'}`}
            </div>
          </div>
        ) : null}
        {bnbReward > 0 ? <i className="driver add" /> : null}
        <ul className="vote-ext">
          {options.map((item, key) => (
            <li key={key}>
              <span>{profitExt.replace(/@1/ig, item.coin)}</span>
              <div className="bnb-info">
                <i style={{ backgroundImage: `url(${item.coinImg})` }} />
                {`${formatNumber(item.reward)} ${item.coin}`}
              </div>
            </li>
          ))}
        </ul>
      </VoteResult>
    );
  }

  const [profitObject] = options.map(opts => ({
    ...opts,
    profit: opts.coin === optionCoin ? optionProfit : 0,
    isTrue: opts.coin === optionCoin,
  })).filter(v => v.isTrue);

  if (profitObject || bnbProfit) {
    return (
      <VoteResultCenter>
        <b className="res-tel">{successText}</b>
        <div className="profit-list">
          {[{
            profit: bnbProfit, coinImg: bnbLogoUrl, coin: 'BNB',
          }, profitObject].filter(v => !!v).map(item => (
            <div className="bnb-info">
              <i style={{ backgroundImage: `url(${item.coinImg})` }} />
              {`${formatNumberForIntegralPart(item.profit)} ${item.coin}`}
            </div>
          ))}
        </div>
      </VoteResultCenter>
    );
  }

  return <VoteResultCenter><b className="res-tel">{failText}</b></VoteResultCenter>;
};

Reward.propTypes = {
  project: object,
  language: object,
  locale: string,
  isLoggedIn: bool,
};

export default React.memo(Reward);
